import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TkButton from "../../components/atoms/TkButton";
import TkDataTable from "../../components/molecules/TkDataTable";
import {
  headTitleList,
  infoManual,
  searchFormList,
  searchFormSchema,
} from "./parts";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { IAPI_STA029_Response } from "../../type/apiType";
import { httpAPI_STA029, httpAPI_STA041 } from "./api/request";
import { Status } from "../../assets/data/Constants";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import { TkRouteContext } from "../../context/tkRouteContext";
import _ from "lodash";
import { toNumberOrUndefined } from "../../utils/useTools";

/**
 * SCRC060118 退職予定者一覧
 * @Todo 持ち回り情報登録 別タスク化
 * @return SCRC060118 退職予定者一覧
 */
const SCRC060118 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const context = businessState.job_32;
  const [stateSearchList, setStateSearchList] = useState<any>();
  const searchList = useRef(_.cloneDeep(searchFormList));
  const [bodyList, setBodyList] = useState<any[]>([]);
  const [resData, setResData] = useState<IAPI_STA029_Response>({});
  const location = useLocation();
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  const facilityNumber =
    state.authInfo?.userType === authorityUserType.userTypeNumber.DAIKOSHA
      ? location.state?.facilityNo ?? context?.facilityNo
      : null;

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  async function handleCallApi(search?: any) {
    // 退職予定者一覧参照API 呼び出し
    try {
      const res = await httpAPI_STA029({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        facilityName: search?.facilityName,
        staffNameKanji: search?.staffNameKanji,
        facilityNo: facilityNumber,
      });

      if (res.resultCd === "I0000") {
        const bodyList =
          res.retireList?.map((item) => {
            let showFlg =
              item.applyId &&
              (item.latestApplyStatus === Status["届出待ち"] ||
                item.latestApplyStatus === Status["差戻し一時保存"]);
            return [
              {
                children:
                  (item.facilityNo ?? "") +
                  ":" +
                  (item.facilityNo === "999"
                    ? "対象外施設"
                    : item.facilityName ?? ""),
                forSort: item.facilityNo,
              },
              {
                children:
                  (item.staffNo ?? "") + ":" + (item.staffNameKanji ?? ""),
                forSort: item.staffNo,
              },
              {
                children: item.birthday,
                forSort: item.birthday,
                align: "center",
              },
              {
                children: item.retireDate,
                forSort: item.retireDate,
                align: "center",
              },
              {
                children: (
                  <Box className="tkCellBtn">
                    <TkButton onClick={() => registerClick(item, search)}>
                      退職情報登録
                    </TkButton>
                    {showFlg && (
                      <TkButton
                        onClick={() => {
                          deleteClick(item.applyId, search);
                          showFlg = false;
                        }}
                      >
                        申請削除
                      </TkButton>
                    )}
                  </Box>
                ),
              },
            ];
          }) ?? [];

        setBodyList(bodyList);

        setResData(res);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        if (res.resultCd === "TKMSG_SVR0017W") {
          setBodyList([]);
        }
      }
    } catch (error) {
      navigate("/error");
    }
  }

  useEffect(() => {
    let resArr = searchList.current;
    resArr.find(
      (item: any) => item.keyword === "facilityName"
    )!.wantToSetValue = context?.facilityNameForSearch;
    resArr.find(
      (item: any) => item.keyword === "staffNameKanji"
    )!.wantToSetValue = context?.staffNameForSearch;
    setStateSearchList([...resArr]);

    handleCallApi({
      facilityName: context?.facilityNameForSearch,
      staffNameKanji: context?.staffNameForSearch,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteClick = async (applyId: any, search?: any) => {
    // 退職届等一時保存データ削除API 呼び出し
    try {
      const res = await httpAPI_STA041({
        applyId: toNumberOrUndefined(applyId),
      });

      if (res.resultCd === "I0000") {
        handleCallApi({ ...search });

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const registerClick = (item: any, search?: any) => {
    setBusinessState({
      ...businessState,
      job_32: {
        applyId: item.applyId,
        staffNo: item.staffNo,
        staffNameKanji: item.staffNameKanji,
        staffNameKana: item.staffNameKana,
        birthday: item.birthday,
        facilityNo: item.facilityNo,
        facilityName: item.facilityName,
        retireDate: item.retireDate,
        facilityNameForSearch: search?.facilityName,
        staffNameForSearch: search?.staffNameKanji,
      },
    });

    // 申請idなし
    if (!item.applyId && item.applyId !== 0) {
      navigate("/SCRC060119");
    } else {
      navigate("/SCRC060120");
    }
  };

  return (
    <Box data-testid="SCRC060118PageForTest" className="tkSCRC060118">
      {infoManual}

      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}
      <TkSearchForm
        listData={stateSearchList}
        ruleSchema={searchFormSchema}
        onSearch={handleCallApi}
      />

      {resData.retireList?.length! > 0 && (
        <TkDataTable
          headList={headTitleList}
          bodyList={bodyList}
          defaultRowsPerPage={10}
          pagin
        />
      )}
    </Box>
  );
};

export default SCRC060118;
